/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AsbConnectionResponse
 */
export interface AsbConnectionResponse {
    /**
     * 
     * @type {string}
     * @memberof AsbConnectionResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AsbConnectionResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof AsbConnectionResponse
     */
    connectionName?: string;
    /**
     * 
     * @type {string}
     * @memberof AsbConnectionResponse
     */
    login?: string;
    /**
     * 
     * @type {number}
     * @memberof AsbConnectionResponse
     */
    wellId: number;
    /**
     * 
     * @type {number}
     * @memberof AsbConnectionResponse
     */
    externalWellId: number;
    /**
     * 
     * @type {string}
     * @memberof AsbConnectionResponse
     */
    connectorType?: AsbConnectionResponseConnectorTypeEnum;
}


/**
 * @export
 */
export const AsbConnectionResponseConnectorTypeEnum = {
    GtrWits: 'GTR_WITS',
    DrillerConsole: 'DRILLER_CONSOLE',
    Ecp: 'ECP'
} as const;
export type AsbConnectionResponseConnectorTypeEnum = typeof AsbConnectionResponseConnectorTypeEnum[keyof typeof AsbConnectionResponseConnectorTypeEnum];


/**
 * Check if a given object implements the AsbConnectionResponse interface.
 */
export function instanceOfAsbConnectionResponse(value: object): value is AsbConnectionResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('wellId' in value) || value['wellId'] === undefined) return false;
    if (!('externalWellId' in value) || value['externalWellId'] === undefined) return false;
    return true;
}

export function AsbConnectionResponseFromJSON(json: any): AsbConnectionResponse {
    return AsbConnectionResponseFromJSONTyped(json, false);
}

export function AsbConnectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AsbConnectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'url': json['url'],
        'connectionName': json['connectionName'] == null ? undefined : json['connectionName'],
        'login': json['login'] == null ? undefined : json['login'],
        'wellId': json['wellId'],
        'externalWellId': json['externalWellId'],
        'connectorType': json['connectorType'] == null ? undefined : json['connectorType'],
    };
}

export function AsbConnectionResponseToJSON(value?: AsbConnectionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
        'connectionName': value['connectionName'],
        'login': value['login'],
        'wellId': value['wellId'],
        'externalWellId': value['externalWellId'],
        'connectorType': value['connectorType'],
    };
}

